import React, { useEffect, useState } from "react";
import { api, useApi } from "../api/api";
import { Container, Dimmer, Loader, Segment, Checkbox, Button, Input } from "semantic-ui-react";
import Table, { TextCell } from "../components/Table";
import { HistoryInterface } from "../api/history";
import Pagination from "../components/Pagination";
import { ActionAccess } from "../api/base";

const ITEMS_PER_PAGE = 15;
const GITLAB_AUTHOR = "G i t l a b";

const History = () => {
    const historyApi = useApi(api.history);
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState<HistoryInterface[]>([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [ignoreGitlab, setIgnoreGitlab] = useState(false);

    const [searchQuery, setSearchQuery] = useState("");
    const [submittedQuery, setSubmittedQuery] = useState<string | null>(null);

    const load = async () => {
        setLoading(true);

        const response = await historyApi.index(
            currentPage,
            ITEMS_PER_PAGE,
            ignoreGitlab ? GITLAB_AUTHOR : null,
            submittedQuery,
        );

        setHistory(response.items);
        setTotalPages(Math.ceil(response.count / ITEMS_PER_PAGE));

        setLoading(false);
    };

    useEffect(() => {
        load().catch(console.error);
    }, [currentPage, ignoreGitlab, submittedQuery]);

    const handleSearchKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            setSubmittedQuery(searchQuery);
        }
    };

    if (loading) {
        return (
            <Dimmer inverted active>
                <Loader />
            </Dimmer>
        );
    }

    const isDisabled = () => {
        return historyApi.getAccessLevel("") !== ActionAccess.ALLOWED;
    };

    const onRemove = async () => {
        setLoading(true);
        await historyApi.removeOldRecords();
        await load();
    };

    const highlightText = (text: string) => {
        if (!submittedQuery || !text) {
            return <span>{text}</span>;
        }

        const escapedSearchValue = submittedQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(`(${escapedSearchValue})`, "gi");
        const parts = text.split(regex);

        return (
            <span>
                {parts.map((part, index) =>
                    regex.test(part) ? (
                        <mark key={index} style={{ backgroundColor: "yellow" }}>
                            {part}
                        </mark>
                    ) : (
                        <span key={index}>{part}</span>
                    ),
                )}
            </span>
        );
    };

    return (
        <Container>
            <Segment>
                <Container style={{ display: "flex" }}>
                    <Checkbox
                        label="Ignore GitLab author"
                        checked={ignoreGitlab}
                        onChange={() => setIgnoreGitlab(!ignoreGitlab)}
                        style={{ marginLeft: "10px", alignContent: "center" }}
                    />
                    <Button circular onClick={onRemove} disabled={isDisabled()} style={{ marginLeft: "10px" }}>
                        Remove old records
                    </Button>
                    <Input
                        icon="search"
                        placeholder="Search..."
                        iconPosition="left"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={handleSearchKeyDown}
                        className={"search"}
                        style={{ flex: "1", marginLeft: "13px" }}
                    />
                </Container>

                {history.length === 0 ? (
                    <Segment>History is empty</Segment>
                ) : (
                    <Table rows={history}>
                        <TextCell header="entity" value={(row) => highlightText(row.entity)} />
                        <TextCell header="action" value={(row) => highlightText(row.action)} />
                        <TextCell header="author" value={(row) => highlightText(row.author)} />
                        <TextCell header="created_at" value={(row) => highlightText(row.created_at)} />
                        <TextCell header="description" value={(row) => highlightText(row.description)} />
                    </Table>
                )}

                <Pagination
                    activePage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(activePage) => setCurrentPage(activePage)}
                />
            </Segment>
        </Container>
    );
};

export default History;
